import React, { useRef } from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import FeatureSection from '../FeatureSection';
import RoomTypesSection from '../RoomTypesSection'
import SpecialOfferBanner from '../SpecialOfferBanner';
import TestimonialsSection from '../TestimonialsSection';
import LocationSection from '../LocationSection';
import SocialMediaSection from '../SocialMediaSection';

const Home = () => {
    window.scroll(0,0);
    
    return (
        <>
        <HeroSection/>
        <FeatureSection/>
        <RoomTypesSection/>
        <SpecialOfferBanner/>
        <LocationSection/>      
        </>
    ); 
}
export default Home;